import formatHour from './formatHour';
import dayjs from 'dayjs';

const formatFinalDate = (length, date) => {
  let finalDate = '';

  if (length > 2) {
    if (date.consecutive === true) {
      let firstDay = date['days'][0];
      let lastDay = date['days'][date['days'].length - 1];
      finalDate += `${firstDay} a ${lastDay}`;
    } else {
      date.days.forEach((day, index) => {
        if (index + 1 === length) {
          finalDate += `y ${day}`;
        } else if (index + 1 === length - 1) {
          finalDate += `${day} `;
        } else {
          finalDate += `${day}, `;
        }
      });
    }
  } else if (length === 2) {
    date.days.forEach((day, index) => {
      if (index + 1 === length) {
        finalDate += `y ${day}`;
      } else {
        finalDate += `${day} `;
      };
    });
  } else {
    finalDate += date.days[0];
  }

  return finalDate;
};

const formatSchedule = (rawDate) => {
  const dateNames = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
  let arrangedRawDate = rawDate;
  let arrangedDates = {};
  let sortableArrangedDates = [];
  let sortedDates = [];
  let finalDates = [];
  let currentDate = {};
  let otherDaysOpen = [];

  if (rawDate.length > 1) {
    arrangedRawDate = rawDate.sort((a, b) => {
      if (a.day === 0) return 1;
      if (b.day === 0) return -1;
    });
  }

  // First, it arranges by schedule
  arrangedRawDate.forEach((date) => {
    arrangedDates[`${date.starthours}-${date.endhours}`] = [];
  });

  arrangedRawDate.forEach((date) => {
    arrangedDates[`${date.starthours}-${date.endhours}`].push(date.day);
  });

  // Then its converted in an array in order to make sortable by how many days that schedule has.
  for (var date in arrangedDates) {
    if (date) {
      sortableArrangedDates.push([date, arrangedDates[date]]);
    }
  }

  // Then it sorts the array.
  sortableArrangedDates.sort((a, b) => {
    return b[1].length - a[1].length;;
  });

  // Almost finishing: Arranges the array with the correct day name and not number, also adds the schedule in a more semantic way.
  sortableArrangedDates.forEach((date) => {
    let groupsDate = {
      'days': [],
      'schedule': date[0],
      'consecutive': false
    };

    let datesNumbers = [];

    date[1].forEach((date) => {
      if (date - 1 !== -1) {
        datesNumbers.push(date - 1)
      } else {
        datesNumbers.push(6)
      }
    });

    datesNumbers.sort((a, b) => {
      return a - b;
    });

    let arentConsecutive = datesNumbers.some((el, index, items) => {
      if (index < items.length - 1) {
        return items[index] + 1 !== items[index + 1];
      }
    });

    if (!arentConsecutive) {
      groupsDate.consecutive = true;
    }

    datesNumbers.forEach((currentDate) => {
      groupsDate.days.push(dateNames[currentDate]);
    });

    sortedDates.push(groupsDate);
  });

  // Finally transforms the array of objects into an array of the the final dates to print on the render.
  sortedDates.forEach((date) => {
    const { length } = date.days;
    const schedule = date.schedule.split('-');
    let finalDate = formatFinalDate(length, date);

    schedule.forEach((hour, index) => {
      if (hour.length < 4 && hour !== '0') {
        schedule[index] = `0${hour}`;
      } else if (hour === '0') {
        schedule[index] = `000${hour}`;
      }
    });

    let finalScheduleStart = formatHour(schedule[0]);
    let finalScheduleEnd = formatHour(schedule[1]);

    date.days.forEach((day) => {
      if (day.toLowerCase() === dayjs().format('dddd').toLowerCase()) {
        currentDate.day = day.toLowerCase();
        currentDate.startHour = finalScheduleStart;
        currentDate.endHour = finalScheduleEnd;
      } else {
        otherDaysOpen.push(day);
      }
    });

    finalDate += `: ${formatHour(schedule[0])} - ${formatHour(schedule[1])}`;
    finalDates.push(finalDate);
  });

  return {
    finalDates,
    currentDate,
    otherDaysOpen
  };
};

export default formatSchedule;
